import styled from 'styled-components'

import Button from '../Button/Button'

const Bedroom = styled(Button).attrs({
  as: 'span',
  type: 'white',
})`
  cursor: default;
  flex: 1;
  border-radius: 0;
  border: 0;
  border-top: 1px solid ${props => props.theme.colors[props.active ? 'secondary' : 'gray200']};

  padding: ${props => (props.theme.gutter * 2) / 3}px 0;

  display: flex;
  flex-direction: column;
  align-item: center;
  justify-content: center;
  text-align: center;
`

export default Bedroom
